import _ from 'lodash';
import React from 'react';
import Debug from 'debug';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import config from '../../config/client';
import StoreStore from '../../stores/StoreStore';
// import styles from './index.sass';
import banquetIconPng from './images/banquet_icon_120.png';
import banquetIconSvg from './images/banquet-app-icon.svg';
import buttonMenuClosePng from '../images/button_menu_close.png';
import buttonMenuCloseSvg from '../images/button_menu_close.svg';

const debug = Debug('delectable');
const ItunesURL = 'https://itunes.apple.com/us/app/banquet-shop-top-wine-stores/id1058119446?mt=8';
export const ColorSchemes = {
  Light: 'light',
  Dark: 'dark'
};

class DownloadBanner extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func,
    getUserAgent: React.PropTypes.func,
    getExperimentSetting: React.PropTypes.func
  };

  static propTypes = {
    className: React.PropTypes.string,
    onDismiss: React.PropTypes.func,
    store: React.PropTypes.object,
    useragent: React.PropTypes.object,
    colorScheme: React.PropTypes.oneOf(_.values(ColorSchemes)),
    dismissable: React.PropTypes.bool,
    renderStoreNameAsLink: React.PropTypes.bool
  };

  static defaultProps = {
    className: '',
    colorScheme: ColorSchemes.Dark,
    renderStoreNameAsLink: true
  };

  constructor(props) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  getStateFromProps(props) {
    return {
      store: props.store
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickDismiss(e) {
    this.props.onDismiss && this.props.onDismiss();
  }

  render() {
    if(!this.state || !this.state.store) {return null;}
    if(this.context.getExperimentSetting && this.context.getExperimentSetting('download_banner_dismissed')) {return null;}

    let store = this.state.store;
    let useragent = this.props.useragent;
    if(this.context.getUserAgent) {
      useragent = this.context.getUserAgent();
    }
    if(!useragent.isiOs && !useragent.isAndroid) {return null;}
    let downloadUrl = store.get('referral_link_url') || ItunesURL;
    let banquetIconSrc = banquetIconPng;
    let banquetIconSrcSet = banquetIconSvg;
    if(!banquetIconPng.match(/^http/)) {
      banquetIconSrc = config.CDN + banquetIconPng;
    }
    if(!banquetIconSvg.match(/^http/)) {
      banquetIconSrcSet = config.CDN + banquetIconSvg;
    }
    let dismissButton;
    if(this.props.dismissable) {
      dismissButton = <button className="dismiss" onClick={this.handleOnClickDismiss.bind(this)}><img src={buttonMenuClosePng} srcSset={buttonMenuCloseSvg} /></button>;
    }
    let storeName;
    if(this.props.renderStoreNameAsLink) {
      storeName = <a href={store.get('about_url')} className="name" target="_blank">{store.get('name')} on Banquet</a>;
    } else {
      storeName = <p className="name">{store.get('name')} on Banquet</p>;
    }
    return (
      <div className={`banquetbanner banquetbanner--${this.props.colorScheme} ${this.props.className}`}>
        <style type="text/css" dangerouslySetInnerHTML={{__html: styles}}></style>
        {dismissButton}
        <img className="icon" src={banquetIconSrc} srcSet={banquetIconSrcSet} alt="Banquet by Delectable App Icon" style={{borderRadius: useragent.isAndroid ? 100 : 7}} />
        <div className="details">
          {storeName}
          <p className="subtext">Install from the {useragent.isiOs ? 'App Store' : 'Play Store'}</p>
        </div>
        <a className="downloadButton" href={downloadUrl}>Get</a>
      </div>
    );
  }
}

DownloadBanner = connectToStores(DownloadBanner, [StoreStore], (context, props) => {
  let store = context.getStore(StoreStore).getCurrentStore();
  return {
    store : store
  };
});

export default DownloadBanner;

const styles = `
  .banquetbanner {
    width: 100%;
    height: 50px;
    padding: 6px 10px;
    background-color: #262626;
    -webkit-font-smoothing: antialiased;
    font-family: -apple-system, 'Helvetica Neue', HelveticaNeue, 'Roboto', 'Segoe UI', sans-serif;
  }
  .banquetbanner:after {
    content:"";
    display:block;
    clear:both;
  }
  .banquetbanner--light {
    background-color: #f7f6f5;
  }
  .banquetbanner, .banquetbanner *, .banquetbanner *:before, .banquetbanner *:after {
    box-sizing: border-box;
  }
  .banquetbanner .dismiss {
    float: left;
    width: 21px;
    height: 32px;
    padding: 9px 7px 9px 0;
    margin: 3px 0 0 0;
    background-color: transparent;
  }
  .banquetbanner .dismiss img {
    width: 14px;
    height: 14px;
  }
  .banquetbanner .icon {
    float: left;
    width: 32px;
    margin-top: 3px;
    border-radius: 12px;
    border: 1px solid rgba(0,0,0,0.06);
  }
  .banquetbanner .details {
    float: left;
    margin-left: 12px;
    max-width: 200px;
    max-width: calc(100% - 100px);
  }
  .banquetbanner .dismiss ~ .details {
    max-width: 175px;
    max-width: calc(100% - 121px);
  }
  .banquetbanner .details .name {
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    font-weight: 600;
    max-width: 100%;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-decoration: none;
  }
  .banquetbanner--light .details .name {
    color: rgba(0,0,0,0.7);
  }
  .banquetbanner .details .name:active, .banquetbanner .details .name:hover {
    outline: 0;
    text-decoration: none;
  }
  .banquetbanner .details .subtext {
    margin: 0;
    padding: 0;
    font-size: 11px;
    line-height: 18px;
    color: rgba(255,255,255,0.7);
  }
  .banquetbanner--light .details .subtext {
    color: rgba(0,0,0,0.5);
  }
  .banquetbanner .downloadButton {
    display: block;
    float: right;
    width: 54px;
    height: 34px;
    border-radius: 4px;
    border: 1px solid rgba(255,255,255,0.2);
    line-height: 34px;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    margin-top: 2px;
    text-align: center;
    text-decoration: none;
  }
  .banquetbanner--light .downloadButton {
    color: #000000;
    font-weight: 600;
    border: 1px solid rgba(0,0,0,0.5);
  }
`;



// WEBPACK FOOTER //
// banquet/components/DownloadBanner/index.js